import React from 'react';
import { Box, Link, Typography } from '@material-ui/core';
import BaseWidth from '../../../components/base-width';
import Helmet from 'react-helmet';

const ServiceNo = () => (
  <BaseWidth maxWidth={'lg'}>
    <Helmet title={'Om Världens bibliotek'} />
    <Box pt={5} pb={5}>
      <Typography variant="h1" component="h1" gutterBottom={true}>
        Om Världens bibliotek
      </Typography>
      <Typography>
        Världens bibliotek är ett digitalt bibliotek. Här finns ljudböcker och
        e-böcker på flera av Sveriges migrantspråk. Du läser och lyssnar på
        webbsidan. Det enda du behöver göra för att komma igång är att skapa en
        användarprofil med hjälp av din mejladress.
        <br />
        <br />
      </Typography>
      <Typography>
        Världens bibliotek är en del av Sveriges allmänna bibliotekssystem som
        finansieras av skattepengar. Därför är Världens bibliotek alltid gratis
        att använda för alla i Sverige.
        <br />
        <br />
      </Typography>
      <Typography>
        Världens bibliotek drivs och bekostas av:
        <Typography>
          {'\u2022'}{' '}
          <Link
            href="https://www.kb.se/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Kungliga biblioteket
          </Link>
          , som är Sveriges nationalbibliotek och en statlig myndighet.
        </Typography>
        <Typography>
          {'\u2022'}{' '}
          <Link
            href="https://www.kulturradet.se/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Kulturrådet
          </Link>
          , som är en statlig myndighet med ansvar för att fördela kulturbidrag.
        </Typography>
        <Typography>
          {'\u2022'}{' '}
          <Link
            href="https://www.nb.no/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Nasjonalbiblioteket
          </Link>{' '}
          i Norge, som är det norska nationalbiblioteket.
        </Typography>
        <Typography>
          {'\u2022'}{' '}
          <Link
            href="https://malmo.se"
            rel="noopener noreferrer"
            target="_blank"
          >
            Biblioteken i Malmö
          </Link>
          , som är det folkbibliotek som har fått i uppdrag att utveckla och
          förvalta Världens bibliotek.
        </Typography>
        <Typography>
          {'\u2022'}{' '}
          <Link
            href="https://stockholm.se"
            rel="noopener noreferrer"
            target="_blank"
          >
            Stockholms stadsbibliotek
          </Link>
          , som är ett folkbibliotek och deltar som samarbetspartner i arbetet
          med Världens bibliotek.
        </Typography>
      </Typography>
    </Box>
  </BaseWidth>
);

export default ServiceNo;
